import React from 'react';
import Link from 'next/link';

const BlogLink = ({ internal, external, children}) => {
  if (internal) {
    return (
      <Link href={internal}>
        <a target="_blank" rel="noreferrer">
          { children }
        </a>
      </Link>
    );
  }

  if (external) {
    return (
      <a href={external} target="_blank" rel="noreferrer">
        { children }
      </a>
    );
  }

  return <>{ children }</>;
};

export default BlogLink;
